import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  show: boolean;
};

const initialState: InitialState = {
  show: false,
};

const maintenanceBannerSlice = createSlice({
  name: "maintenanceBanner",
  initialState,
  reducers: {
    setBannerVisibility(state, action: PayloadAction<{ show: boolean }>) {
      state.show = action.payload.show;
    },
  },
});

export const { setBannerVisibility } = maintenanceBannerSlice.actions;

export default maintenanceBannerSlice;
